<template>
  <b-container fluid>
    <form  @submit.prevent="onSave" action="#">
      <b-row v-if="loading_detail">
        <b-col md="12">
          <div class="text-center my-5">
            <b-spinner type="grow" label="Spinning"></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12" class="mb-4">
          <div :class="`d-flex align-items-center justify-content-end w-100`">
            <b-button
              v-if="isEdit"
              :disabled="saving"
              block
              type="button"
              variant="danger"
              style="width:15%"
              @click="isEdit = false"
            >
              <div>
                <i class="fa fa-ban"></i>
                <span>Cancel</span>
              </div>
            </b-button>

            <b-button
              type="button"
              v-else
              block
              variant="primary"
              style="width:15%"
              @click="isEdit = true"
            >
              <div>
                <i class="fa fa-pen"></i>
                <span>Edit Data</span>
              </div>
            </b-button>
          </div>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="Vehicle"
            label-for="vehicle_id"
          >
            <v-multiselect 
              v-if="isEdit"
              v-model="form.vehicle_id" 
              :options="listVehicle" 
              placeholder="Select vehicle" 
              track-by="name" 
              label="name"
              @input="onSelectedVehicle"
              disabled
            >
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </v-multiselect>
            <strong v-else>{{ form?.vehicle_id?.name }}</strong>
          </b-form-group>
        </b-col>
        <b-col md="12" v-if="form.vehicle_id">
          <b-form-group
            label="Collection Forms"
            label-for="collection_forms"
          >
            <v-multiselect 
              v-if="isEdit"
              v-model="form.collection_of_forms_id" 
              :options="listCollectionForm" 
              placeholder="Select forms" 
              track-by="name" 
              label="name"
              @input="onSelectedForm"
              disabled
            >
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </v-multiselect>
            <strong v-else>{{ form?.collection_of_forms_id?.name }}</strong>
          </b-form-group>
        </b-col>

        <b-col md="12" v-if="detailForm">
          <b-row class="mt-2">
            <div class="border my-2 mx-3 w-100"></div>
            <b-col md="12" >
              <b-row>
                <b-col md="12">
                  <b-form-group label="Title">
                    <b-form-input v-if="isEdit" v-model="form.title" type="text" placeholder="Type Text" required  />
                    <strong v-else>{{ form?.title }}</strong>
                  </b-form-group>
                </b-col>
                <template v-if="isEdit">
                  <b-col md="6" v-for="(state, index) in detailForm?.field" :key="index">
                    <b-form-group :label="state?.label">
                      <b-form-input v-model="state.value" type="number" placeholder="Type Number" v-if="state.type === 'Numeric Type'" :required="state?.required" />
                      <b-form-input v-model="state.value" placeholder="Type Text" v-if="state.type === 'Text Type'" :required="state?.required" />
                      <b-form-textarea v-model="state.value" placeholder="Type Text" v-if="state.type === 'Textarea'" :required="state?.required" />
                      <b-form-input v-model="state.value"  type="date" v-if="state.type === 'Date'" :required="state?.required" />
                      <b-form-input v-model="state.value" type="datetime-local" v-if="state.type === 'Datetime'" :required="state?.required" />
                      <b-form-checkbox v-model="state.value" name="check-button" switch v-if="state.type === 'Boolean Type'">Yes / No </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </template>
                <template v-else>
                  <b-col md="6" v-for="(state, index) in detailForm?.field" :key="index">
                    <b-form-group :label="state?.label">
                      <strong>{{ handleTypeDate(state?.value) }}</strong>
                    </b-form-group>
                  </b-col>
                </template>
              </b-row>
            </b-col>
            <div class="border my-2 mx-3 w-100"></div>
            
            <b-col md="12">
              <fieldset class="form-group border p-3">
                <legend class="w-auto px-2 text-primary">Question Type Content</legend>
                <div v-if="detailForm.collection_of_forms_category.length > 0">
                  <table class="table table-striped" v-for="(parentQuestion, parentQuestionIndex) in detailForm.collection_of_forms_category" :key="parentQuestionIndex">
                    <thead>
                      <tr v-if="!parentQuestion.parent_id && parentQuestion?.inspection_checklist_question?.length <= 0">
                        <th colspan="6" class="align-middle text-center">{{ parentQuestion?.name }}</th>
                      </tr>
                      <tr v-else>
                        <th style="width:5%">No</th>
                        <th style="width:45%">{{parentQuestion?.name }}</th>
                        <template v-if="Array.isArray(detailForm?.question_type_content)">
                          <th  style="min-width:20%" class="text-truncate" v-for="(questionType, questionTypeIndex) in detailForm?.question_type_content" :key="questionTypeIndex">
                            {{ questionType?.label }}
                          </th>
                        </template>
                        <template v-else>
                          <th  style="width:50%" v-if="['date', 'single-lines-text-box', 'datetime', 'numerical-value'].includes(detailForm.question_type.code)">{{ detailForm?.question_type_content?.label }}</th>
                        </template>
                        <th  style="width:20%" v-if="detailForm.using_remarks">Remarks</th>
                      </tr>
                    </thead>
                    <tbody v-if="parentQuestion?.inspection_checklist_question?.length > 0">
                      <tr v-for="(question, questionIndex) in parentQuestion?.inspection_checklist_question" :key="questionIndex">
                        <td style="max-width:20px">{{ questionIndex + 1 }}</td>
                        <td>{{ question.question }}</td>
                        <template v-if="detailForm.question_type.code == 'multiple-choice-multiple-answers-allowed'">
                          <td v-for="(questionType, questionTypeIndex) in detailForm?.question_type_content" :key="questionTypeIndex">
                            <b-form-checkbox v-if="isEdit" v-model="question.answer[questionTypeIndex].value" :value="questionType?.label" :unchecked-value="''" />
                            <span v-else>{{ question.answer[questionTypeIndex].value ? '✔️' : '' }}</span>
                          </td>
                        </template>
                        <template v-if="detailForm.question_type.code == 'multiple-choice-only-one-answer'">
                          <td v-for="(questionType, questionTypeIndex) in detailForm.collection_of_forms_category[parentQuestionIndex].inspection_checklist_question[questionIndex].answer" :key="questionTypeIndex">
                            <template>
                              <b-form-checkbox  
                                v-if="isEdit" 
                                name="check-button" 
                                switch
                                inline
                                v-model="questionType.value" 
                                @change="onChangeAnswer(parentQuestionIndex, questionIndex, questionTypeIndex)" 
                              />
                              <span v-else>{{ question.answer[questionTypeIndex].value ? '✔️' : '' }}</span>
                            </template>
                          </td>
                        </template>
                        <template v-if="['single-lines-text-box'].includes(detailForm.question_type.code)">
                          <td>
                            <b-form-input v-if="isEdit" v-model="question.answer" type="text" />
                            <span v-else>{{ handleTypeDate(question.answer) }}</span>
                          </td>
                        </template>
                        <template v-if="['multiple-lines-text-box'].includes(detailForm.question_type.code)">
                          <td v-for="(questionType, questionTypeIndex) in detailForm?.question_type_content" :key="questionTypeIndex">
                            <b-form-input v-if="isEdit" v-model="question.answer[questionTypeIndex].value" placeholder="Type Text" />
                            <span v-else>{{ handleTypeDate(question.answer[questionTypeIndex].value) }}</span>
                          </td>
                        </template>
                        <template v-if="['numerical-value'].includes(detailForm.question_type.code)">
                          <td>
                            <b-form-input v-if="isEdit" v-model="question.answer" type="number" />
                            <span v-else>{{ handleTypeDate(question.answer) }}</span>
                          </td>
                        </template>
                        <template v-if="['date'].includes(detailForm.question_type.code)">
                          <td>
                            <b-form-input v-if="isEdit" v-model="question.answer" type="date" />
                            <span v-else>{{ handleTypeDate(question.answer) }}</span>
                          </td>
                        </template>
                        <template v-if="['datetime'].includes(detailForm.question_type.code)">
                          <td>
                            <b-form-input v-if="isEdit" v-model="question.answer" type="datetime-local" />
                            <span v-else>{{ handleTypeDate(question.answer) }}</span>
                          </td>
                        </template>
                        <td v-if="detailForm.using_remarks">
                          <b-form-textarea v-if="isEdit" v-model="question.remarks" />
                          <span v-else>{{ handleTypeDate(question?.remarks) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </fieldset>
            </b-col>

            <div class="border my-2 mx-3 w-100"></div>

            <b-col md="12" class="mt-2">
              <b-row>
                <template v-if="isEdit">
                  <b-col md="3" v-for="(state, index) in detailForm?.signature" :key="index">
                    <b-form-group :label="state?.label">
                      <b-form-input v-model="state.value" type="number" placeholder="Type Number" v-if="state.type === 'Numeric Type'" :required="state?.required" />
                      <b-form-input v-model="state.value" placeholder="Type Text" v-if="state.type === 'Text Type'" :required="state?.required" />
                      <b-form-textarea v-model="state.value" placeholder="Type Text" v-if="state.type === 'Textarea'" :required="state?.required" />
                      <b-form-input v-model="state.value" type="date" v-if="state.type === 'Date'" :required="state?.required" />
                      <b-form-input v-model="state.value" type="datelocal-time" v-if="state.type === 'Datetime'" :required="state?.required" />
                      <b-form-checkbox v-model="state.value" name="check-button" switch v-if="state.type === 'Boolean Type'" >Yes / No </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </template>
                <template v-else>
                  <b-col md="3" v-for="(state, index) in detailForm?.signature" :key="index">
                    <b-form-group :label="state?.label">
                      <strong>{{ handleTypeDate(state?.value) }}</strong>
                    </b-form-group>
                  </b-col>
                </template>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="12" v-if="form.vehicle_id && form.collection_of_forms_id && isEdit">
          <div class="d-flex align-items-center justify-content-end w-100">
            <b-button
              block
              variant="danger"
              type="button"
              style="width:15%"
              class="mr-4 mt-2"
              @click="isEdit = false"
            >
              <i class="fa fa-remove"></i>
              <span>Cancel</span>
            </b-button>

            <b-button
              :disabled="saving"
              block
              variant="primary"
              type="submit"
              style="width:20%"
            >
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm"
              />
              <div v-else>
                <i class="fa fa-save"></i>
                <span>Submit Data</span>
              </div>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>

<script>
import { busdevActions, fleetsActions } from '@src/Utils/helper'
import _ from 'lodash'
import SlideDetailForm from '@src/views/Setting/SlideDetailForm.vue'
import moment from 'moment'

export default {
  name: 'DetailEditInspectionChecklist',
  props:{
    editId: {
      type: Number,
      default: null
    }, 
    resetFormToInitialValue: {
      type: Function,
      default: true
    },
  },
  components:{
    SlideDetailForm
  },
  data () {
    return {
      isEdit:false,
    
      listCollectionForm: [],
      listVehicle: [],
      listTypeData: [
        {text:'Numeric Type', value:'Numeric Type'},
        {text:'Text Type', value:'Text Type'},
        {text:'Textarea', value:'Textarea'},
        {text:'Date', value:'Date'},
        {text:'Datetime', value:'Datetime'},
        {text:'Boolean Type', value:'Boolean Type'},
        {text:'Select Option', value:'Select Option'},
      ],

      loading_fleet_form: false,
      loading_detail: false,
      edit_loading: false,
      loading:false,
      saving:false,
      delete:false,

      detailForm:null,

      form: {
        vehicle_id: null,
        collection_of_forms_id: null,
        title:''
      },
    }
  },
  watch:{
    'editId': {
      handler(value) {
        if(value){
          this.getDetailInspectionChecklist()
        } else {
          this.resetForm()
        }
      },
      immediate: true,
    },
  },
  async mounted () {
    await this.fetchFleets()
  },
  methods: {
    ...busdevActions,
    ...fleetsActions,
    handleTypeDate(value){
        if(this.validDate(value)){
          return moment(value).format('DD MMMM YYYY')
        } else if (this.validDateTime(value)){
          return moment(value).format('HH:mm A')
        } else {
          return value
        }
      },
      validDate(val, format = 'YYYY-MM-DD'){
        return moment(val, format, true).isValid();
      },  
      validDateTime(val, format = 'YYYY-MM-DDTHH:mm'){
        return moment(val, format, true).isValid();
      },  
    async onSelectedVehicle(){
      if(this.form.vehicle_id.vehicleType.id) await this.getVehicleTypeForm()
    }, 
    onChangeAnswer(firstIndex, secondIndex, thirdIndex){
      console.log(this.detailForm.collection_of_forms_category[firstIndex].inspection_checklist_question[secondIndex].answer)
      this.detailForm.collection_of_forms_category[firstIndex].inspection_checklist_question[secondIndex].answer.forEach((val, valIndex) => {
        if(valIndex !== thirdIndex){
          val.value = false
        }
      })
    },
    onSelectedForm(){
      this.detailForm = this.form.collection_of_forms_id

      this.detailForm.question_type_content = JSON.parse(this.detailForm.question_type_content)
      this.detailForm.signature = JSON.parse(this.detailForm.signature).map(val => {return {...val, value:''}})
      this.detailForm.field = JSON.parse(this.detailForm.field).map(val => {return {...val, value:''}})
      this.detailForm.collection_of_forms_category = this.modifyQuestionsValue(this.detailForm.collection_of_forms_category, this.detailForm.question_type.code, this.detailForm.question_type_content)

      this.form.title = `${this.form.vehicle_id.vehicleType.name} - Inspection Report`
    },
    modifyQuestionsValue(oldVal, questionType, content){
      let newVal = oldVal
      if(questionType === 'multiple-lines-text-box'){
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.remarks = ''
              obj.answer = content.map(() => {
                  return {
                    value: ''
                  }
                })
              return obj
            })
          }
          return val
        })
      } else if(questionType === 'single-lines-text-box'){
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.answer = ''
              obj.remarks = ''
              return obj
            })
          }
          return val
        })
      } else if(questionType === 'numerical-value'){
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.answer = ''
              obj.remarks = ''
              return obj
            })
          }
          
          return val
        })
      } else if(questionType === 'date'){
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.answer = ''
              obj.remarks = ''
              return obj
            })
          }
          return val
        })
      } else if(questionType === 'datetime'){
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.answer = ''
              obj.remarks = ''
              return obj
            })
          }
          return val
        })
      } else if(questionType === 'multiple-choice-only-one-answer'){
        newVal = newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.answer = ""
              obj.remarks = content.map((s,i) => {
                  return {
                    index: i,
                    value: ''
                  }
                })
              return obj
            })
          }
          
          return val
        })
      } else if(questionType === 'multiple-choice-multiple-answers-allowed'){ 
        newVal.map(val => {
          if(val.inspection_checklist_question.length > 0){
            val.inspection_checklist_question.map(obj => {
              obj.remarks = ''
              obj.answer = content.map((s,i) => {
                  return {
                    index: i,
                    value: ''
                  }
                })
              return obj
            })
          }
          return val
        })
      }

      return newVal
    },
    async fetchFleets() {
      let params = this.$options.filters.cleanObject({
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
      })
      
      let res = await this.getFleets(params)

      if (res.status) {
        if (res.data && res.data.length > 0) {
          this.listVehicle = res.data
        }
      }
    },

    async getDetailInspectionChecklist() {
      this.loading_detail = true
      this.detailForm = null

      let res = await this.fetchInspectionChecklistById({id: this.editId})
      if (res?.data?.status === true) {

        let questionContent = JSON.parse(res.data.data.question_content)

        this.form = {
          vehicle_id: res.data.data.vehicle,
          collection_of_forms_id: res.data.data.collection_of_forms,
          title:res.data.data.title
        }
       
        this.detailForm = {
          ...res.data.data.collection_of_forms,
          collection_of_forms_category:questionContent,
          field:JSON.parse(res?.data?.data?.field),
          signature:JSON.parse(res?.data?.data?.signature),
          question_type_content:JSON.parse(res.data.data.collection_of_forms.question_type_content),
        }

        this.loading_detail = false
      }

      this.loading_detail = false
    },

    resetForm () {
      this.form = {
        vehicle_id: null,
        collection_of_forms_id: null,
        title: ''
      }
      this.detailForm = null
      this.isEdit = false
    },

    async onSave () {
      this.saving = true
      let tempPayload = {
        ...this.form,
        ...this.detailForm
      }

      let payload = {
        vehicle_id: tempPayload.vehicle_id.id,
        collection_of_forms_id: tempPayload.collection_of_forms_id.id,
        field: tempPayload.field.map(val => {
          return {
            label: val.label,
            type: val.type,
            required: val.required,
            value: val.value,
          }
        }),
        signature: tempPayload.signature.map(val => {
          return {
            label: val.label,
            type: val.type,
            required: val.required,
            value: val.value,
          }
        }),
        question_content:JSON.stringify(tempPayload.collection_of_forms_category),
        title: this.form.title
      }

      payload.field = JSON.stringify(payload.field)
      payload.signature = JSON.stringify(payload.signature)

      let res = await this.updateInspectionChecklist({data: payload, id: this.editId})

      if (res?.data?.status === true) {
        this.$swal(`Update Inspection Checklist Success!`, res.data.message, 'success')
        this.resetForm()
        this.saving = false

        this.resetFormToInitialValue()
      } else {
        this.$swal(
          `Oops!`,
          res?.data,
          'error'
        )
        this.saving = false
      }
      this.saving = false
    },
  }
}
</script>

<style scoped>
</style>
